import React, { FC, useState } from 'react';
import { Button, Table } from 'react-bootstrap';

//Icons
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

//Types
import { TableColumnInterface, TableOptionsInterface } from './Types';

//Styles
import './styles.scss'

interface ActivityTableProps {
    data: Array<any>,
    columns: Array<TableColumnInterface>,
    options?: TableOptionsInterface
}

interface PaginatorProps {
    func: Function
}

interface SearchProps {
    func: Function
}

const Paginator: FC<PaginatorProps> = (props: PaginatorProps) => {
    return (
        <div className='paginator'>
            <Button className='paginator-button'>
                <FaChevronLeft />
            </Button>
            <Button className='paginator-button'>
                <FaChevronRight />
            </Button>
        </div>
    )
};

const Search: FC<SearchProps> = (props: SearchProps) => {
    const { func } = props;

    const [search, setSearch] = useState("");

    const handleSearchEnter = (target: HTMLInputElement) => {
        setSearch(target.value)
        func(target.value)
    }
console.log("search", search);
    return (
        <div className='search-container' >
            <input
                className='search-field'
                placeholder='Buscar'
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearchEnter(e.target as HTMLInputElement)}
            ></input>
            <Button onClick={() => func(search)} className='paginator-button'>
                Buscar
            </Button>
        </div>
    )
};

const ActivityTable: FC<ActivityTableProps> = (props: ActivityTableProps) => {
    const { columns, data, options } = props;
    
    return (
        <div>
            {(options && options.search) &&
                <Search func={options && options.search} />
            }
            {(options && options.topPaginator) &&
                <Paginator func={options && options.topPaginator} />
            }
            <div style={{ height: options?.height, overflowY: options?.height ? "auto" : "unset" }}>
                <Table bordered responsive="sm">
                    <thead>
                        <tr>
                            {options?.multiSelect &&
                                <th key={"multi-select"} />}
                            {columns.map((column) => (
                                <th key={column.value}>
                                    {column.title ? column.title : ''}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, rowKey) =>
                            <tr key={`row-${rowKey}`}>
                                {options?.multiSelect &&
                                    <td key={`check-${rowKey}`}>
                                        <div style={{ textAlign: "center" }}>
                                            <input
                                                className="activity-table-checkbox"
                                                id="toggle-check"
                                                type="checkbox"
                                                // variant="secondary"
                                                checked={options?.multiSelect?.values.find((multi: any) => multi === (options?.multiSelect?.key ? row[options?.multiSelect?.key] : row.id)) || false}
                                                // value="1"
                                                onChange={(e) => options?.multiSelect?.func(options?.multiSelect?.key ? row[options?.multiSelect?.key] : row.id, e.currentTarget.checked)}
                                            />
                                        </div>
                                    </td>}
                                {columns.map((column, columnKey) => (
                                    <td className="activity-table-td" key={`${column.value}-${columnKey}`}>
                                        {column.render ?
                                            column.render(row) :
                                            row[column.value]}
                                    </td>
                                ))}
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            {(options && options.bottomPaginator) &&
                <Paginator func={options && options.bottomPaginator} />
            }
        </div>
    )
};

export default ActivityTable;
